import * as React from 'react'

// Import About styling
import './About.css'

const About: React.FunctionComponent = () => {
  return (
    <div className="row white box-shadow" id="about">
      <div className="side-content"></div>
      <div className="main-content">
        <div className="content-header">
          <a className="anchor"></a>
          <h2>About</h2>
        </div>
        <div className="content-body">
          <p>A young and aspiring self taught Web Developer, constantly pushing to learn more and take on different technologies and projects.</p>
          <p>Looking to get a foot in the door in the industry to gain experience working with teams and projects on much larger scales.</p>
          <p>I see myself as someone young and willing to learn who may just be looking for the opportunity to prove himself, step up and take his development to the next level.</p>
          <hr />
          <p>I currently have a few side projects in the work to put in my personal portfolio as well as a Fullstack Web Application, stay tuned for more about that in the future!</p>
          <p className="text-center"><b>Check out all of my public repositories currently available below.</b></p>
        </div>
      </div>
      <div className="side-content"></div>
    </div>
  )
}

export default About
